var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "23px",
    viewBox: "0 0 20 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Nav",
    transform: "translate(-1371.000000, -26.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(1371.066667, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7020005,17.3732676 C18.6894735,17.3621875 18.6769464,17.351292 18.6644194,17.3402119 C17.8350567,16.6181562 17.3577402,15.5718219 17.3577402,14.4706409 L17.3577402,9.23856314 L17.3512925,9.23856314 C17.3533189,9.16585897 17.3546085,9.09291473 17.3546085,9.01969349 C17.3546085,5.55609795 14.9389191,2.65819882 11.7044229,1.92628188 C11.7103548,1.86757562 11.7134129,1.80801988 11.7134129,1.74774394 C11.7134129,0.782479301 10.9328134,0 9.96989053,0 C9.00698604,0 8.2263866,0.782479301 8.2263866,1.74774394 C8.2263866,1.82940455 8.23209745,1.90973554 8.24291122,1.98842299 C5.13633804,2.81086465 2.84593737,5.64708435 2.84593737,9.01969349 C2.84593737,9.09291473 2.84715323,9.16585897 2.84929019,9.23856314 L2.84919808,9.23856314 L2.84919808,14.2405434 C2.84919808,15.3873376 2.33260569,16.4728218 1.44309483,17.193954 C1.3769595,17.247508 1.31257428,17.3018007 1.25001285,17.3566474 C0.502075782,18.0133302 0.0542346482,18.9438771 0,19.9333333 L19.9333333,19.9333333 C19.879725,18.9521872 19.4407265,18.0269957 18.7020005,17.3732676",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9,19.9333333 C6.90280228,21.6274436 8.27468099,23 9.96663768,23 C11.6585944,23 13.0304344,21.6274436 13.0333333,19.9333333 L6.9,19.9333333",
    id: "Fill-12"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bell-icon.f590bbb7f33c3efeba1532dd3fbf4705.svg";